import React, {useEffect, useMemo, useState} from "react";
import {ToastContainer} from "react-toastify";
import SideBar from "../../../common/SideBar";
import NavBar from "../../../common/NavBar";
import {Link} from "react-router-dom";
import Spinner from "reactjs-simple-spinner";
import PermissionsService from "../../../services/PermissionsService";
import CssBaseline from "@material-ui/core/CssBaseline";
import EnhancedTable from "./tableComponent/EnhancedTable";
import RolesEnhancedTable from "./rolesTableComponent/EnhancedTable";
import UserService from "../../../services/UserService";


const ViewPermissions = () => {
    const [loading, setLoading] = useState(true);

    const columns = useMemo(
        () => [
            {
                Header: "Id",
                accessor: 'id'
            },
            {
                Header: 'Authority',
                accessor: 'name',
            },
            {
                Header: 'CreatedAt',
                accessor: 'created_at',
            },
            {
                Header: 'UpdatedAt',
                accessor: 'updated_at',
            },
            // {
            //     Header: 'Actions',
            //     accessor: 'description',
            // },
        ],
        []
    )

    const rolesColumns = useMemo(
        () => [
            {
                Header: "Id",
                accessor: 'id'
            },
            {
                Header: 'Role',
                accessor: 'name',
            },
            {
                Header: 'CreatedAt',
                accessor: 'created_at',
            },
            {
                Header: 'UpdatedAt',
                accessor: 'updated_at',
            },
            // {
            //     Header: 'Actions',
            //     accessor: 'description',
            // },
        ],
        []
    )

    const [data, setData] = useState([])
    const [roles, setRoles] = useState([])
    const [skipPageReset, setSkipPageReset] = useState(false)
    const [skipRolesPageReset, setSkipRolesPageReset] = useState(false)

    // We need to keep the table from resetting the pageIndex when we
    // Update data. So we can keep track of that flag with a ref.

    // When our cell renderer calls updateMyData, we'll use
    // the rowIndex, columnId and new value to update the
    // original data
    const updateMyData = (rowIndex, columnId, value) => {
        // We also turn on the flag to not reset the page
        setSkipPageReset(true)
        setData(old =>
            old.map((row, index) => {
                if (index === rowIndex) {
                    return {
                        ...old[rowIndex],
                        [columnId]: value,
                    }
                }
                return row
            })
        )
    }
    const updateMyRoles = (rowIndex, columnId, value) => {
        // We also turn on the flag to not reset the page
        setSkipRolesPageReset(true)
        setRoles(old =>
            old.map((row, index) => {
                if (index === rowIndex) {
                    return {
                        ...old[rowIndex],
                        [columnId]: value,
                    }
                }
                return row
            })
        )
    }

    useEffect(() => {
        setLoading(true);
        PermissionsService.getAll()
            .then(res => {
                console.log("res: ", res)
                if (res.status === 200) {
                    console.log(res.data);
                    setData(res.data.data);
                    UserService.getAllRoles()
                        .then(res => {
                            console.log(res.data);
                            let d = [];
                            res.data.data.map((roles, i) => {
                                if (roles[0].name !== 'sysadmin') {
                                    console.log("no. ", i, "role: ", roles[0])
                                    d.push(roles[0])
                                }
                            })
                            console.log("data: ", d)
                            setRoles(d)
                            setLoading(false);
                        })
                        .catch(err => {
                            console.log(err);
                            setRoles([])
                            setLoading(false);
                        });
                } else {
                    setData([]);
                    console.log("res: ", res.response.data.message)
                    setLoading(false);
                }

            })
            .catch(err => {
                console.log(err.response.data.message);
                setData([]);
                setLoading(false);
            });


    }, []);

    return (
        <>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            {/* Same as */}
            <ToastContainer/>

            <SideBar roles={JSON.parse(localStorage.getItem('roles'))}/>
            <div
                id="main-content"
                className="main-panel ps-container ps-theme-default">
              <NavBar roles={JSON.parse(localStorage.getItem('roles'))}/>

                <div className="content">
                    <div className="container-fluid">
                        <ul className="breadcrumb">
                            <Link to="/dashboard"><a href><i className="fa fa-home"/>&nbsp;Dashboard</a> </Link>
                             &nbsp;|&nbsp;
                            <Link to="/settings"><a href><i className="fa fa-cog"/>&nbsp;Settings</a></Link>
                             &nbsp;|&nbsp;
                            <span className="upper-class"><i className="fa fa-user"/>&nbsp;IAM Roles Management</span>
                        </ul>
                        <div className="row mt">
                            <div className="col-lg-12">
                                <div className="content-panel bg-white p-4">
                                    <div className="row mb-5">
                                        <div className="col-md-3">
                                            <Link to={'/view-permissions'}
                                                  className="btn btn-sm btn-round btn-primary">
                                                        <span>
                                                            Manage Roles & Permissions &nbsp;&nbsp;<i
                                                            className="fa fa-arrow-circle-right"/>
                                                        </span>
                                            </Link>
                                        </div>
                                        <hr/>
                                        <div className="col-md-3"/>
                                        <div className="col-md-3"/>
                                    </div>
                                    {loading && (
                                        <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                                            <Spinner
                                                size="large"
                                                message="Getting Data,Please wait....."
                                                line-fg-color="#64c3c2"
                                            />
                                        </div>
                                    )}
                                    {!loading && (
                                        <>
                                            {/*    table of Sale army*/}
                                            <CssBaseline/>
                                            <h5 className="h3 pl-4 pt-2 title">Roles</h5>
                                            <RolesEnhancedTable
                                                columns={rolesColumns}
                                                data={roles}
                                                setData={setRoles}
                                                updateMyData={updateMyRoles}
                                                skipPageReset={skipRolesPageReset}
                                            />

                                            <h5 className="h3 pl-4 pt-2 title">Permissions</h5>
                                            <EnhancedTable
                                                columns={columns}
                                                data={data}
                                                setData={setData}
                                                updateMyData={updateMyData}
                                                skipPageReset={skipPageReset}
                                            />

                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )

}

export default ViewPermissions;
